var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.02943 0.499603H1.3C0.858171 0.499603 0.5 0.857775 0.5 1.2996V14.1996C0.5 14.6414 0.858172 14.9996 1.3 14.9996H16.7C17.1418 14.9996 17.5 14.6414 17.5 14.1996V4.01835C17.5 3.57653 17.1418 3.21835 16.7 3.21835H5.8189C5.56272 3.21835 5.32204 3.09567 5.17153 2.88836L3.6768 0.829593C3.5263 0.622289 3.28561 0.499603 3.02943 0.499603ZM11.7998 10.0496C12.1864 10.0496 12.4998 9.7362 12.4998 9.3496C12.4998 8.963 12.1864 8.6496 11.7998 8.6496H9.6498V6.4996C9.6498 6.113 9.3364 5.7996 8.9498 5.7996C8.5632 5.7996 8.2498 6.113 8.2498 6.4996V8.6496H6.0998C5.71321 8.6496 5.3998 8.963 5.3998 9.3496C5.3998 9.7362 5.71321 10.0496 6.0998 10.0496H8.2498V12.1996C8.2498 12.5862 8.5632 12.8996 8.9498 12.8996C9.3364 12.8996 9.6498 12.5862 9.6498 12.1996V10.0496H11.7998Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.85792627fe8bf4def2012b4f2fc0d090.svg";
export { ForwardRef as ReactComponent };